module.exports = __webpack_public_path__ + "img/schoolAlert.9e34dc83.jpg";